(function () {
    function processDeferredInlineScripts () {
        document
            .querySelectorAll('script[type="text/javascript/deferred"]')
            .forEach(function (deferred) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.textContent = deferred.innerHTML;
                document.head.appendChild(script);
            });

        document.dispatchEvent(
            new CustomEvent('aw-inline-scripts-proccessed', { bubbles: true })
        );
    }

    // Run via setTimeout, not right away, so the rest of the bundle finishes first.
    // The deferred scripts set window.adw.posts.* (e.g. the "load more" init), which
    // isn't defined yet when this file runs. Waiting a tick lets it exist first.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(processDeferredInlineScripts, 0);
        });
        return;
    }

    setTimeout(processDeferredInlineScripts, 0);
})();
